import { useCallback } from 'react'

import set from 'lodash/set'

import { deepCopy } from '@/utils/object'

import { useCustomizableValue } from '../hooks/use-customizable-value'
import { TableCustomizerProvider } from '../state/table-customizer'

interface Props<Data extends object> {
  name: string
  data: Data[]
  getEmptyRow: () => Data
  children: (props: { data: Data[] }) => JSX.Element
  dateRange: string
}

export const EditTableWrapper = <Data extends object>({
  data,
  name,
  getEmptyRow,
  children,
  dateRange,
}: Props<Data>) => {
  const { value, onChange } = useCustomizableValue({
    name,
    originalValue: data,
    dateRange,
  })

  const onAddEntry = useCallback(() => {
    onChange([getEmptyRow(), ...(value ?? [])])
  }, [onChange, value, getEmptyRow])

  const onCellEdit = useCallback(
    (path: string, newValue: string) => {
      const newTableData = set(deepCopy(value), path, newValue)

      onChange(newTableData)
    },
    [onChange, value],
  )

  return (
    <TableCustomizerProvider
      onAddNewRow={onAddEntry}
      onCellEdit={onCellEdit}
    >
      {children({ data: value })}
    </TableCustomizerProvider>
  )
}
